@for (message of messages; track trackByMessageId($index, message)) {
  <div class="toaster-container" [ngClass]="getPositionClass(message.position)">
    <div class="toast" [ngClass]="getMessageClass(message.type)" [@slideInOut]>
      <div class="toast-content">
        <div class="toast-icon">
          <span class="icon">{{ getMessageIcon(message.type) }}</span>
        </div>
        <div class="toast-body">
          @if (message.title) {
            <div class="toast-title">{{ message.title }}</div>
          }
          <div class="toast-message">{{ message.message }}</div>
        </div>
        @if (message.dismissible) {
          <div class="toast-actions">
            <button
              class="toast-close"
              (click)="dismissMessage(message.id)"
              aria-label="Close notification">
              <span class="close-icon">×</span>
            </button>
          </div>
        }
      </div>
      @if (message.duration && message.duration > 0) {
        <div class="toast-progress">
          <div class="progress-bar"
            [ngClass]="'progress-' + message.type"
            [style.animation-duration]="message.duration + 'ms'"
          [style.animation-delay]="'0ms'"></div>
        </div>
      }
    </div>
  </div>
}
